import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./spawneranim-monoblue-0000.png"),
            require("./spawneranim-monoblue-0001.png"),
            require("./spawneranim-monoblue-0002.png"),
            require("./spawneranim-monoblue-0003.png"),
            require("./spawneranim-monoblue-0004.png"),
            require("./spawneranim-monoblue-0005.png"),
            require("./spawneranim-monoblue-0006.png"),
            require("./spawneranim-monoblue-0007.png"),
            require("./spawneranim-monoblue-0008.png"),
            require("./spawneranim-monoblue-0009.png"),
            require("./spawneranim-monoblue-0010.png"),
            require("./spawneranim-monoblue-0011.png"),
            require("./spawneranim-monoblue-0012.png"),
            require("./spawneranim-monoblue-0013.png"),
            require("./spawneranim-monoblue-0014.png"),
            require("./spawneranim-monoblue-0015.png"),
        ]
    })
}
